import { Map } from 'immutable';
import Constants from '../constants/index';
import { ACTION_SUCCESS, ACTION_ERROR } from '../constants/action-status';

export const DEFAULT_STATE = Map({
	cloudId: null,
	userIsAdmin: false,
});

export default function aggregatedDataReducer(state = DEFAULT_STATE, action) {
	switch (action.type) {
		case `${Constants.FETCH_AGGREGATED_DATA}_${ACTION_SUCCESS}`:
			return state.withMutations((state) => {
				state.set('cloudId', action.payload.results.cloudId);
				state.set('userIsAdmin', action.payload.results.adminUser);
			});
		case `${Constants.FETCH_AGGREGATED_DATA}_${ACTION_ERROR}`:
			return state.withMutations((state) => {
				state.set('cloudId', null);
				state.set('userIsAdmin', false);
			});
		default:
			return state;
	}
}
